var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/events", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.event
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.updateEvent.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.title,
                              expression: "rules.title"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Event Title",
                            placeholder: "Enter Event Title",
                            "data-vv-name": "title",
                            "cus-name": "title",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.title,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "title", $$v)
                            },
                            expression: "event.title"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.type.length
                      ? _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.type,
                                  expression: "rules.type"
                                }
                              ],
                              attrs: {
                                label: "Type",
                                "data-vv-name": "type",
                                "cus-name": "type",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.type,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.event.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.event, "type", $$v)
                                },
                                expression: "event.type"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.tags,
                              expression: "rules.tags"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Event Tags",
                            placeholder: "Enter Comma separated Tags",
                            "data-vv-name": "tags",
                            "cus-name": "tags",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.tags,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "tags", $$v)
                            },
                            expression: "event.tags"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("label", [_vm._v("Start Date")]),
                        _vm._v(" "),
                        _c("datetime", {
                          attrs: {
                            "input-class": "form-control",
                            placeholder: "Choose a Date",
                            type: "datetime",
                            "min-datetime": _vm.today,
                            "input-format": "DD-MM-YYYY HH:mm",
                            "auto-continue": ""
                          },
                          model: {
                            value: _vm.startDate,
                            callback: function($$v) {
                              _vm.startDate = $$v
                            },
                            expression: "startDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("label", [_vm._v("End Date")]),
                        _vm._v(" "),
                        _c("datetime", {
                          attrs: {
                            "input-class": "form-control",
                            placeholder: "Choose a Date",
                            type: "datetime",
                            "input-format": "DD-MM-YYYY HH:mm",
                            "auto-continue": ""
                          },
                          model: {
                            value: _vm.endDate,
                            callback: function($$v) {
                              _vm.endDate = $$v
                            },
                            expression: "endDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.duration,
                              expression: "rules.duration"
                            }
                          ],
                          attrs: {
                            type: "number",
                            label: "Event Duration",
                            placeholder: "Enter Event Duration",
                            "data-vv-name": "duration",
                            "cus-name": "duration",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.duration,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "duration", $$v)
                            },
                            expression: "event.duration"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.description,
                              expression: "rules.description"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            label: "Event Description",
                            placeholder: "Enter Event Description",
                            "data-vv-name": "description",
                            "cus-name": "description",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.description,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "description", $$v)
                            },
                            expression: "event.description"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.longDescription,
                              expression: "rules.longDescription"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            label: "Long Description",
                            placeholder: "Enter Event Long Description",
                            "data-vv-name": "Long Description",
                            "cus-name": "Long Description",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.longDescription,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "longDescription", $$v)
                            },
                            expression: "event.longDescription"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-image", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.img_url,
                              expression: "rules.img_url"
                            }
                          ],
                          attrs: {
                            type: "file",
                            label: "Event Image",
                            placeholder: "Enter Comma separated Tags",
                            "data-vv-name": "event image",
                            "cus-name": "event image",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          on: { file: _vm.updateValue },
                          model: {
                            value: _vm.event.img_url,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "img_url", $$v)
                            },
                            expression: "event.img_url"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.authBanner,
                              expression: "rules.authBanner"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            label: "Auth Banner",
                            placeholder: "Enter Auth Banner Text",
                            "data-vv-name": "authBanner",
                            "cus-name": "authBanner",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.authBannerText,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "authBannerText", $$v)
                            },
                            expression: "event.authBannerText"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.unAuthBanner,
                              expression: "rules.unAuthBanner"
                            }
                          ],
                          attrs: {
                            rows: "5",
                            label: "Unauth Banner",
                            placeholder: "Enter Unauth Banner Text",
                            "data-vv-name": "unAuthBanner",
                            "cus-name": "unAuthBanner",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.unAuthBannerText,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "unAuthBannerText", $$v)
                            },
                            expression: "event.unAuthBannerText"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Video Code",
                            placeholder: "Enter Video Code"
                          },
                          model: {
                            value: _vm.event.jw_stream_title,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "jw_stream_title", $$v)
                            },
                            expression: "event.jw_stream_title"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.event.type == "1" || !_vm.event.type
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-input", {
                              attrs: {
                                type: "text",
                                label: "JW RTMP URL",
                                placeholder: "Enter JW RTMP URL"
                              },
                              model: {
                                value: _vm.event.jw_rtmp_url,
                                callback: function($$v) {
                                  _vm.$set(_vm.event, "jw_rtmp_url", $$v)
                                },
                                expression: "event.jw_rtmp_url"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.chatroll_event_name,
                              expression: "rules.chatroll_event_name"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Chat Roll Event Name",
                            placeholder: "Enter Chat Roll Event Name",
                            "data-vv-name": "chatroll_event_name",
                            "cus-name": "chatroll_event_name",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.chatroll_event_name,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "chatroll_event_name", $$v)
                            },
                            expression: "event.chatroll_event_name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.experts.length
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  placeholder: "Select Expert(s)",
                                  multiple: true,
                                  options: _vm.experts.map(function(type) {
                                    return type.expertId
                                  }),
                                  "custom-label": function(opt) {
                                    return _vm.experts.find(function(x) {
                                      return x.expertId == opt
                                    }).name
                                  },
                                  required: ""
                                },
                                model: {
                                  value: _vm.event.csvExpertsIds,
                                  callback: function($$v) {
                                    _vm.$set(_vm.event, "csvExpertsIds", $$v)
                                  },
                                  expression: "event.csvExpertsIds"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                          >\n                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Has Playlist Archive",
                            placeholder: "0 or 1, 1 if true",
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.toneLive,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "toneLive", $$v)
                            },
                            expression: "event.toneLive"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "number",
                            label: "Switch Time (Minutes)",
                            placeholder: "Enter Switch Time (Optional)"
                          },
                          model: {
                            value: _vm.event.eventSwitchTime,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "eventSwitchTime", $$v)
                            },
                            expression: "event.eventSwitchTime"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.corporations.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              attrs: {
                                label: "Corporation (Optional)",
                                list: _vm.corporations,
                                selectedKey: "corporationId"
                              },
                              model: {
                                value: _vm.event.corporationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.event, "corporationId", $$v)
                                },
                                expression: "event.corporationId"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.eventType.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.isPrivate,
                                  expression: "rules.isPrivate"
                                }
                              ],
                              attrs: {
                                label: "Event Visibility",
                                "data-vv-name": "Event Visibility",
                                "cus-name": "Event Visibility",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.eventType,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.event.isPrivate,
                                callback: function($$v) {
                                  _vm.$set(_vm.event, "isPrivate", $$v)
                                },
                                expression: "event.isPrivate"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Enable Corporate Archive",
                            placeholder: "0 or 1, 1 if true",
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.event.corporateEventArchive,
                            callback: function($$v) {
                              _vm.$set(_vm.event, "corporateEventArchive", $$v)
                            },
                            expression: "event.corporateEventArchive"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.status.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.status,
                                  expression: "rules.status"
                                }
                              ],
                              attrs: {
                                label: "Status",
                                "data-vv-name": "status",
                                "cus-name": "status",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.status,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.event.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.event, "status", $$v)
                                },
                                expression: "event.status"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: {
                        type: "submit",
                        disabled:
                          _vm.errors.any() ||
                          !_vm.event.csvExpertsIds ||
                            _vm.event.csvExpertsIds.length === 0
                      }
                    },
                    [
                      _vm._v(
                        "\n                        Update Event\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Edit Event")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-666d3434", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-666d3434","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Events/EditEvent.vue
// module id = MqwA
// module chunks = 0